import { ISO_DATE_FORMAT } from "../../../const/DateFormatConsts";

import { gaEvent, trackGoal } from "../../../shared/helpers/gtm_tracking";

const arrivalDataQueryParam = arrivalDate => {
  return arrivalDate
    ? `&arrival_date=${arrivalDate.format(ISO_DATE_FORMAT)}`
    : "";
};

const handleClick = (action, label) => e => {
  gaEvent("Search Page", `Package: ${action}`, label);
  trackGoal("CLICKED_PACKAGE");

  const { target } = e;
  const link = target.closest("[href]") || target.closest("[data-href]");

  if (link && !link.href) {
    window.location.href = link.dataset.href;
  }
};

const venueLink = props => {
  return props.lmd
    ? `/${props.venueUrl}`
    : `/${props.venueUrl}?package=${props.id}${arrivalDataQueryParam(props.arrivalDate)}`;
};

export {
  handleClick,
  venueLink
};



// WEBPACK FOOTER //
// ./components/search/package/helpers.js